import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=71dfb14f&scoped=true&"
import script from "./ProfileCard.vue?vue&type=script&lang=ts&"
export * from "./ProfileCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=71dfb14f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dfb14f",
  null
  
)

export default component.exports